import { type ColumnsState, createColumnsHook } from './createColumnsHook';

/** Ordem de exibição. "Ações" fica de fora: é sempre visível. */
export const ALLOCATION_COLUMNS = [
  'project',
  'contract',
  'client',
  'unit',
  'allocatedPercentage',
  'billable',
  'costShare',
  'salesProfile',
  'monthlyCost',
  'allocatedCost',
  'monthlyGrossRevenue',
  'monthlyNetRevenue',
  'ebitdaPercentage',
  'startDate',
  'endDate',
  'notes',
  'tags',
  'accountDirector',
  'operationsManager',
  'projectManager',
] as const;

export type AllocationColumn = (typeof ALLOCATION_COLUMNS)[number];

export const DEFAULT_VISIBLE_COLUMNS: readonly AllocationColumn[] = [
  'project',
  'contract',
  'client',
  'allocatedPercentage',
  'billable',
  'startDate',
  'endDate',
];

export const ALLOCATION_COLUMN_LABEL_KEYS = {
  project: 'tabela.projeto',
  contract: 'tabela.contrato',
  client: 'tabela.cliente',
  accountDirector: 'tabela.diretorConta',
  operationsManager: 'tabela.gerenteOperacao',
  projectManager: 'tabela.gerenteProjeto',
  unit: 'tabela.unidade',
  allocatedPercentage: 'tabela.percAlocado',
  billable: 'tabela.faturando',
  costShare: 'tabela.custoBrUs',
  salesProfile: 'tabela.perfilVenda',
  monthlyCost: 'tabela.custoMes',
  allocatedCost: 'tabela.custoAlocado',
  monthlyGrossRevenue: 'tabela.fatBrutoMes',
  monthlyNetRevenue: 'tabela.fatLiquidoMes',
  ebitdaPercentage: 'tabela.ebitda',
  startDate: 'tabela.inicio',
  endDate: 'tabela.fim',
  notes: 'filtros.anotacoes',
  tags: 'form.tags',
} as const satisfies Record<AllocationColumn, string>;

export const useAllocationColumns = createColumnsHook({
  columns: ALLOCATION_COLUMNS,
  defaultColumns: DEFAULT_VISIBLE_COLUMNS,
  storageKey: 'allocation-table-columns',
  version: 4,
});

export type AllocationColumnsState = ColumnsState<AllocationColumn>;
